import { Button } from 'components/Button/Button';
import { Modal } from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';

type ConfirmTransactionsModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading: boolean;
};

export const ConfirmTransactionsModal: React.FC<ConfirmTransactionsModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}) => {
    const { t } = useTranslation('documents');

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="space-y-4">
                <h3 className="text-lg font-semibold">{t('confirmExportTitle')}</h3>
                <p className="text-sm text-zinc-600">{t('confirmExportMessage')}</p>
                <div className="flex justify-end gap-2">
                    <Button variant="outline" onClick={onClose} disabled={isLoading}>
                        {t('cancelButton')}
                    </Button>
                    <Button onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? t('exportingButton') : t('exportButton')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
